import { render } from "./AssistantMobileIcon.vue?vue&type=template&id=c63caf66&scoped=true"
import script from "./AssistantMobileIcon.vue?vue&type=script&lang=js"
export * from "./AssistantMobileIcon.vue?vue&type=script&lang=js"

import "./AssistantMobileIcon.vue?vue&type=style&index=0&id=c63caf66&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c63caf66"],['__file',"src/Components/ChatWidget/ChatAssistant/AssistantMobileIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c63caf66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c63caf66', __exports__)) {
    api.reload('c63caf66', __exports__)
  }
  
  module.hot.accept("./AssistantMobileIcon.vue?vue&type=template&id=c63caf66&scoped=true", () => {
    api.rerender('c63caf66', render)
  })

}


export default __exports__